module.exports = __webpack_public_path__ + "img/加油站.33356ebe.png";